<template>
    <div style="width: 100%;">
        <div class="row col-12 justify-content-center">
            <div v-for="(data, i) in bookingData.monthList" :key="i" class="col-md-1 col-2 p-0">
                <a class="p-2 btn month-btn" :href="getMonthLink(data)"
                    target="_blank"
                    :class="{ 'month-btn-actived': data == bookingData.month }">
                    {{ data }}월
                </a>
            </div>
            <!-- dayHeadList -->
            <!-- //dayHeadList -->
            <!-- box -->
            <div class="row col-12 p-0 justify-content-center" style="display: flex;">
                <div v-for="(data, i) in bookingData.dayList"
                    v-bind:class="{ 'bg-satday': data.text == '토', 'bg-sunday': data.text == '일' }"
                    class="justify-content-center col-md-2 col-2 p-0" 
                    v-if="i < 6"
                >
                    <div class="col-12 p-0 flex">
                        <div class="col-12 p-2 content-center"
                            style="border:thin solid darkgray; text-align: center;"
                            v-bind:class="{ 'bg-day': data.text !== '토' && data.text !== '일' }"
                        >
                            <div>
                                <div style="color:black;">{{ bookingData.month }}.{{ data.day }} ({{ data.text }})</div>
                            </div>
                            <!-- <div style="width: 100%; text-align: center; color:blue;">{{ data.fishType }}</div>
                            <div style="width: 100%; text-align: center; color:red;">
                                <span class="p-0">{{ data.leftSeat }}명</span>
                            </div> -->
                            <a @click="openBookingPage(bookingData.month,data.day, data.fishType)">
                                <span class="btn btn-primary p-0 bookkingBtn" style="width: 100%;">예약하기</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- //box -->
        </div>
    </div>
</template>
<script>
import BookingJS from "@/components/booking.js";

export default {
    name: "bookingHead",
    components: {
        BookingJS
    },
    data() {
        return {
            bookingData: BookingJS.getBookingData(),
        }
    },
    mounted() {
        var spanElement = document.getElementsByClassName("bookkingBtn");
        if (window.innerWidth <= 600) {
            for(var i = 0; i < spanElement.length; i++){
                spanElement[i].innerHTML = "예약<br>하기"
            }
        }        
    },
    methods: {
        getMonthLink(month) {
            // 현재 날짜를 기준으로 현재 달의 마지막 날짜를 구하기
            let currentDate = new Date();
            let currentMonth = currentDate.getMonth() + 1;
            let currentYear = currentDate.getFullYear();

            //년(year) 결정
            currentYear = currentMonth > month ? parseInt(currentYear+1) : currentYear;                

            let goMonth = this.addZero(month);

            return `writeBooking`;
            // return `writeBooking${currentYear}`+`${goMonth}`;
            // return `/booking?month=${month}`;
        },
        openBookingPage(month, day, fishType){
            let url = '/writeBooking?month='+month + '&day=' + day + '&fishType=' + fishType;
            let newWindow = window.open(url, '_blank', 'location=no,toolbar=no');
        },
        addZero(num) {
            return num < 10 ? '0' + num : num.toString();
        }
    },
};
</script>
<style>
.flex {
    display: flex;
}

.content-center {
    align-items: center;
    justify-content: center;
}

.font-head {
    font-weight: bold;
    font-size: x-large;
    color: black;
}

.font-red {
    color: red;
}

.bg-dayhead {
    background-color: lightslategrey;
}

.bg-sunday {
    background-color: #f0808069;
}

.bg-satday {
    background-color: #87cefa5e;
}

.bg-day {
    background-color: #dcdcdc54;
}

.month-btn {
    width: 100%;
    border: 1px solid !important;
    border-radius: 1rem !important;
}

.month-btn:hover {
    background-color: lightgray;
}

.month-btn:active {
    background-color: #172b4d;
    color: white;
}

.month-btn-actived {
    background-color: #172b4d;
    color: white;
}

.border-black {
    border-color: rgba(0, 0, 0, 52%) !important;
}


.font-sun {
    color: red !important;
}

.font-sat {
    color: #009be8 !important
}

.font-past {
    opacity: .3 !important;
}

.selected-day {
    background-color: lightsteelblue;
    border-radius: 1rem;
}

.disabled {
    pointer-events: none;
    cursor: not-allowed;
}
</style>
